import React, {Fragment, useEffect } from 'react';
import Axios from 'axios';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { BACKEND_URL_PORTAIL } from '../../config/const';
import axios from "axios";
import {  Container,Spinner} from "reactstrap";
import { useNavigate } from 'react-router-dom';

function ReRoute() {
 
   var params=null
console.log(window.name)
 
    var raw = window.name;
    if (typeof raw === 'string' && raw.startsWith('REROUTE:')) {
      console.log("yess")
      try {
        const json = atob(raw.slice('REROUTE:'.length));
        const parsed = JSON.parse(json);
        params=parsed

        // Optional: persist for reloads
        sessionStorage.setItem('reRouteParams', json);
      } finally {
        // Clear so future pages can’t read it
        window.name = '';
      }
    } else {
      // Fallback if user reloads the page
      const saved = sessionStorage.getItem('reRouteParams');
      if (saved){
        sessionStorage.removeItem('reRouteParams');
        params= saved
      };
    }

   const { token, lang } = params;

  const history = useNavigate ();

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const config = { 
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await axios.get(`${BACKEND_URL_PORTAIL}api/getUserInfos`, config);
            // Save response data to localStorage
        localStorage.setItem("authUser", JSON.stringify(token));
        localStorage.setItem("token",token);
        localStorage.setItem('idUser', response.userInfo.Id);
        localStorage.setItem('username', response.userInfo.UserName);
        localStorage.setItem('lastFailedLogin',"null");
        localStorage.setItem('passwordChange', 0);

        if (!localStorage.getItem('lang')) {
          localStorage.setItem('lang', lang);
        }

        // const passwordChange = localStorage.getItem('passwordChange');
        // const lastFailedLogin = localStorage.getItem('lastFailedLogin');

        // if (passwordChange === 'true' && lastFailedLogin === "null") {
        //   history('/change-password-new');
        // } else if (passwordChange === 'true' && lastFailedLogin !== "null") {
        //   history('/change-password-unblocked');
        // }else {
          history('/home')
       // }

      } catch (error) {
        console.log('Post-login tasks failed:', error);
        // Handle error
      }
    };

    fetchUserInfo();
  }, [token, lang, history]); 

  return (
    <React.Fragment>
        <div className="bg-overlay"></div>
        <div className="d-flex justify-content-center align-items-center vh-100">
            <Container className="text-center">
                <Spinner color="primary" type="border" />
            </Container>
        </div>
    </React.Fragment>
  );
}

export default ReRoute;
